import FlexContainerLayout from "../FlexContainerLayout";

interface IFullHeightContainerLayoutProps {
    content: React.ReactNode;
    footer?: React.ReactNode;
    header?: React.ReactNode;
    showHeader?: boolean;
    showFooter?: boolean;
    contentStyle?: React.CSSProperties;
    headerStyle?: React.CSSProperties;
    footerStyle?: React.CSSProperties;
    scrollContentToBottom?: boolean;
}

/**
 * This is an extension of FlexContainerLayout. It is here for backward compatibility.
 * For new components, please use FlexContainerLayout instead.
 */
function FullHeightContainerLayout({
    content,
    footer,
    header,
    showHeader = false,
    showFooter = true,
    contentStyle = {},
    headerStyle = {},
    footerStyle = {},
    scrollContentToBottom,
    ...props
}: IFullHeightContainerLayoutProps) {
    return (
        <FlexContainerLayout
            id="full-height-container-layout"
            header={header}
            footer={footer}
            showHeader={showHeader}
            showFooter={showFooter}
            contentStyle={contentStyle}
            headerStyle={headerStyle}
            footerStyle={footerStyle}
            scrollContentToBottom={scrollContentToBottom}
            {...props}
        >
            {content}
        </FlexContainerLayout>
    );
}

export default FullHeightContainerLayout;
